import React from "react";
import styles from './final-proof-sent.module.scss';
import { Alert } from "antd"; 
const FinalProofSent = () => {
    return <div className={styles.container}>
        <h3>Task For You</h3>
        <Alert message='Final Proof Sent' description='Final Proof has been sent to Leoprinting. A notification will be sent to you regarding confirmation.'/>
    </div>
}
export default FinalProofSent;